import React, { FocusEvent, ReactNode } from 'react'
import { SetRequired } from 'type-fest'
import { CheckboxIcon, PainPointIcon, ParagraphIcon, StarIcon, TextLineIcon } from '@diversioteam/diversio-ds'
import { nanoid } from 'nanoid'

import { PulseSurveyQuestionType } from 'api/actions/pulseSurveys/pulseSurveysActions.types'

import { FormElement } from './formBuilder.types'

export const DEFAULT_RATING_TYPE = 'star' as const
export const DEFAULT_RATING_WEIGHT = 5 as const

export const DEFAULT_OPTION = [
    {
        id: nanoid(),
        value: 'Option',
    },
]

export const FORM_FIELDS: { label: ReactNode; value: PulseSurveyQuestionType }[] = [
    {
        label: (
            <>
                <PainPointIcon type="line" /> Multiple Choice
            </>
        ),
        value: 'multiple_choice',
    },
    {
        label: (
            <>
                <CheckboxIcon type="line" /> Checkbox
            </>
        ),
        value: 'checkbox',
    },
    {
        label: (
            <>
                <TextLineIcon type="bold" /> Short Answer
            </>
        ),
        value: 'short_answer',
    },
    {
        label: (
            <>
                <ParagraphIcon type="bold" /> Paragraph
            </>
        ),
        value: 'paragraph',
    },
    {
        label: (
            <>
                <StarIcon type="line" /> Rating
            </>
        ),
        value: 'rating',
    },
]

export const isMultipleChoice = (item: FormElement): item is SetRequired<FormElement, 'options' | 'hasOther'> => {
    return item.type === 'multiple_choice' && item.options !== undefined && item.hasOther !== undefined
}

export const isCheckbox = (item: FormElement): item is SetRequired<FormElement, 'options' | 'hasOther'> => {
    return item.type === 'checkbox' && item.options !== undefined && item.hasOther !== undefined
}

export const isRating = (item: FormElement): item is SetRequired<FormElement, 'ratingType' | 'ratingWeight'> => {
    return item.type === 'rating' && item.ratingType !== undefined && item.ratingWeight !== undefined
}

export const focusElement = (event: FocusEvent<HTMLInputElement>) => {
    event.target.select()
}
